// default colour for all categories which don't have a child category
const defaultColor = 'neutral';

// categories with child categories & specified color
const accommodationColor = 'yellow';
const bankChargesColor = 'plum';
const entertainmentColor = 'error';
const incomeColor = 'success';
const investmentColor = 'primary';
const loanColor = 'brown';
const selfTransferColor = 'orange';
const retailColor = 'mint';
const transportColor = 'grass';

export default {
  // Accommodation & Child Categories
  ACCOMMODATION: {
    color: accommodationColor,
    label: 'Accommodation',
  },
  RENT: {
    color: accommodationColor,
    label: 'Rent',
  },
  HOTELS: {
    color: accommodationColor,
    label: 'Hotels',
  },
  // end Accommodation & Child Categories
  // Bank Charges & Child Categories
  BANK_CHARGE: {
    color: bankChargesColor,
    label: 'Bank Charges',
  },
  OVERDRAFT: {
    color: bankChargesColor,
    label: 'Overdraft',
  },
  NSF: {
    color: bankChargesColor,
    label: 'NSF',
  },
  INTEREST_PAID: {
    color: bankChargesColor,
    label: 'Interest Paid',
  },
  // end Bank Charges & Child Categories
  ENTERTAINMENT: {
    color: entertainmentColor,
    label: 'Entertainment',
  },
  GAMBLING: {
    color: entertainmentColor,
    label: 'Gambling',
  },
  // Income & Child Categories
  INCOME: {
    color: incomeColor,
    label: 'Income',
  },
  REVENUE: {
    color: incomeColor,
    label: 'Revenue',
  },
  SALARY: {
    color: incomeColor,
    label: 'Salary',
  },
  INTEREST_RECEIVED: {
    color: incomeColor,
    label: 'Interest Received',
  },
  RETIREMENT: {
    color: incomeColor,
    label: 'Retirement',
  },
  SOCIAL_SECURITY: {
    color: incomeColor,
    label: 'Social Security',
  },
  COMMISSION_RECEIVED: {
    color: incomeColor,
    label: 'Commission Received',
  },
  // end Income & Child Categories
  INFRASTRUCTURE: {
    color: defaultColor,
    label: 'Infrastructure',
  },
  INSURANCE: {
    color: defaultColor,
    label: 'Insurance',
  },
  // Investment & Child Categories
  INVESTMENTS: {
    color: investmentColor,
    label: 'Investments',
  },
  SAVINGS: {
    color: investmentColor,
    label: 'Savings',
  },
  TRADING: {
    color: investmentColor,
    label: 'Trading',
  },
  // end Investment & Child Categories
  // Loan & Child Categories
  LOAN: {
    color: loanColor,
    label: 'Loan',
  },
  MORTGAGE: {
    color: loanColor,
    label: 'Mortgage',
  },
  CARD_REPAYMENT: {
    color: loanColor,
    label: 'Card Repayment',
  },
  MCA: {
    color: loanColor,
    label: 'MCA',
  },
  PAYDAY: {
    color: loanColor,
    label: 'Payday',
  },
  AUTO_LOAN: {
    color: loanColor,
    label: 'Auto Loan',
  },
  BUY_NOW_PAY_LATER: {
    color: loanColor,
    label: 'Buy Now Pay Later',
  },
  // end Loan & Child Categories
  PERSONNEL: {
    color: defaultColor,
    label: 'Personnel',
  },
  REFUND: {
    color: defaultColor,
    label: 'Refund',
  },
  // Retail & Child Categories
  RETAIL: {
    color: retailColor,
    label: 'Retail',
  },
  FOOD_AND_DRINK: {
    color: retailColor,
    label: 'Food & Drink',
  },
  GROCERIES: {
    color: retailColor,
    label: 'Groceries',
  },
  // end Retail & Child Categories
  SELF_TRANSFER: {
    color: selfTransferColor,
    label: 'Self-Transfer',
  },
  TAX: {
    color: defaultColor,
    label: 'Tax',
  },
  TRANSPORT: {
    color: transportColor,
    label: 'Transport',
  },
  UTILITIES: {
    color: defaultColor,
    label: 'Utilities',
  },
  WITHDRAWAL: {
    color: defaultColor,
    label: 'Withdrawal',
  },
};
